import { useEffect, useState } from "react";
import { Col, Label, Row } from "reactstrap";
import axios from "axios";
import { routes } from "./General";
import Select from "react-select";
import { BlkField } from "../coms/BlkField";
import { useDebounce } from "../custom-hooks/useDebounce";

export const ComboCliente = ({ setFieldValue, name, alert, values, typePerson }) => {
    const [client, setClient] = useState({});
    const [clients, setClients] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [text, setText] = useState("");
    const textDebounced = useDebounce(text, 400);

    useEffect(() => {
        if (!values.cdCliente) setClient(null);
    }, [values.cdCliente]);

    useEffect(() => {
        getClients(textDebounced);
    }, [textDebounced]);

    const getClients = value => {
        if (!value.length) {
            setClients([]);
            return;
        }
        setIsLoading(() => true);

        const isClient = typePerson !== 0;
        const suffix = isClient ? "/" + typePerson : "";
        const urlApi = `${routes.api}/polizas/busqueda/${value}${suffix}`;

        axios
            .get(urlApi)
            .then(resp => {
                const data = isClient ? resp.data.values : resp.data;
                data.forEach(p => {
                    p.label = p.rucCed + " - " + p.nmCliente + " " + (p.apCliente ? p.apCliente : "");
                    p.value = p.cdCliente;
                });
                data.sort((p1, p2) => p1.rucCed.localeCompare(p2.rucCed));
                setClients(data);
            })
            .catch(error => {
                alert.current.show_error("Error al consultar " + error);
            })
            .finally(() => setIsLoading(() => false));
    };
    return (
        <Row>
            <Col>
                <div>
                    {typePerson === 0 && <Label>Cliente: </Label>}
                    <BlkField
                        name={name}
                        component={Select}
                        value={client}
                        options={clients}
                        onInputChange={setText}
                        placeholder="Cliente"
                        onChange={e => {
                            setFieldValue(name, e.value);
                            setClient(e);
                        }}
                        classNamePrefix="react-select"
                        className="react-select"
                        noOptionsMessage={() => (isLoading ? "Loading..." : "No options")}
                    />
                </div>
            </Col>
        </Row>
    );
};
